<form [formGroup]="rentalProperty">
<div class="container">

    <div class="row gap-32 rental-property-container">
      <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
            <mat-form-field class="mat-form-field-100"  >
                <mat-label>Property’s street address</mat-label>
                <input [readonly]="true" matInput  formControlName="propertyStreetAddress"  placeholder="Property’s street address"
                       >
         
              </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="mat-form-field-100"  >
                <mat-label>Apt/Unit/Suite</mat-label>
                <input [readonly]="true" matInput formControlName="aptUnitSuite"  placeholder="Apt/Unit/Suite"
                       >
         
              </mat-form-field>
        </div>

        <div class="row gap-10">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <mat-form-field  >
                    <mat-label>City</mat-label>
                    <input [readonly]="true" matInput formControlName="city" placeholder="City"
                           >
             
                  </mat-form-field>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <mat-form-field>
                
                    <mat-label>State</mat-label>
  
                    <input [readonly]="true" [value]="currentState" matInput  placeholder="State">
                  </mat-form-field>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <mat-form-field  >
                    <mat-label>Zip Code</mat-label>
                    <input [readonly]="true" matInput formControlName="zipCode"  placeholder="Zip Code">             
                  </mat-form-field>
            </div>
        </div>
        <div class="row gap-10">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <mat-form-field class="mat-form-field-100"  appearance="outline"  >
                    <mat-label>Property nickname</mat-label>
                    <input   matInput formControlName="propertyNickName" placeholder="Property nickname"
                           >
             
                  </mat-form-field>
            </div>
        </div>
        <div class="row gap-10">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <mat-form-field class="mat-form-field-100"  >
                    <mat-label>Jurisdiction</mat-label>
                    <input [readonly]="true" matInput formControlName="jurisdiction" placeholder="Jurisdiction"
                           >
             
                  </mat-form-field>
            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <mat-form-field class="mat-form-field-100"  >
                    <mat-label>Property type</mat-label>
                    <input [readonly]="true" matInput formControlName="propertyType" placeholder="Property type"
                           >
             
                  </mat-form-field>
            </div>
        </div>
        <div class="row">
                <mat-form-field  class="mat-form-field-100"  >
                    <mat-label>Property appraiser office</mat-label>
                    <input [readonly]="true" matInput [value]="appraiserOfficeName" placeholder="Assigned by the county on approval">
             
                  </mat-form-field> 
        </div>
        <div class="row gap-10">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
             <mat-form-field  >
               <mat-label>Started renting</mat-label>
               <input [readonly]="true"  matInput formControlName="startedRenting"  [matDatepicker]="picker"> 
               <mat-datepicker-toggle matIconSuffix  ></mat-datepicker-toggle>
               <mat-datepicker   #picker></mat-datepicker>
               <mat-error>Started renting is required</mat-error>
             </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
             <mat-form-field  [appearance]="this.externalUser?.accountType == 1 ? 'outline' : 'fill'">
               <mat-label>Filing frequency</mat-label>
               <mat-select   formControlName="filingFrequency"  matNativeControl required>
                 
                 <mat-option  value="M">Monthly</mat-option >
                 <mat-option  value="Q">Quarterly</mat-option >
            
               </mat-select>
               <mat-error>Filing frequency is required</mat-error>
             </mat-form-field>
            </div>
         </div>

         <div *ngIf="this.externalUser?.accountType !=3"  class="row">
                <mat-form-field class="mat-form-field-100" appearance="outline"  >
                    <mat-label>Rental Property Business Name</mat-label>
                    <input matInput formControlName="businessName"  placeholder="Rental Property Business Name"
                           >
             
                  </mat-form-field>
        </div>
      </div>
      <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
        <div *ngIf="this.externalUser?.accountType == 3"  class="form-row">
           
                <mat-form-field  appearance="outline"  >
                    <mat-label>Name on business sign</mat-label>
                    <input matInput formControlName="businessName"  placeholder="Name on business sign"
                           >
             
                  </mat-form-field>
            
        </div>

        <div *ngIf="this.externalUser?.accountType == 3"  class="form-row">
            <div class="form-col">
                <mat-form-field  appearance="outline"  >
                    <mat-label>Website URL (optonal)</mat-label>
                    <input matInput formControlName="webUrl"  placeholder="Website URL (optonal)"
                           >
             
                  </mat-form-field>
            </div>
        </div>

        <div *ngIf="this.externalUser?.accountType ==1"  class="form-row">
            <div class="form-col">
            <mat-checkbox formControlName="usePlatformToRent"  color="primary" class="primary">
                Don’t use any platform to rent out my property 
              
              </mat-checkbox> 
    </div>
</div>
    <div *ngIf="this.externalUser?.accountType ==1"  class="form-row">
        <div class="form-col">
            <mat-form-field appearance="outline" >
              <mat-label>Rental Property link</mat-label>
              <input matInput placeholder="Rental Property link" formControlName="platFormLink" 
                     >
            </mat-form-field>
          
        </div>
   
    </div>
    </div>
    </div>

</div>
</form>
 

